import {
    ValidationMessagesTypes,
    InitValidationMessagesActionType,
    ChangeValidationMessageRequestActionType,
    ChangeValidationMessageSuccessActionType,
    ChangeValidationMessageFailureActionType,
} from "./types";
import { ActionCreator } from "./../types/store-types";

export const changeValidationMessageRequest: ActionCreator<ChangeValidationMessageRequestActionType> = payload => ({
    type: ValidationMessagesTypes.CHANGE_VALIDATION_MESSAGE_REQUEST,
    payload,
});

export const changeValidationMessageSuccess: ActionCreator<ChangeValidationMessageSuccessActionType> = payload => ({
    type: ValidationMessagesTypes.CHANGE_VALIDATION_MESSAGE_SUCCESS,
    payload,
});

export const changeValidationMessagesFailure: ActionCreator<ChangeValidationMessageFailureActionType> = payload => ({
    type: ValidationMessagesTypes.CHANGE_VALIDATION_MESSAGE_FAILURE,
    payload,
});

export const initValidationMessages: ActionCreator<InitValidationMessagesActionType> = payload => ({
    type: ValidationMessagesTypes.INIT_VALIDATION_MESSAGES,
    payload,
});
